import { SvgIcon, SvgIconProps } from '@mui/material';

const LinearChartIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13 17V9" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M18 17V5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M3 3V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H21"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M8 17V14" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
};

export default LinearChartIcon;
